<template>
  <div
    class="
      xl:w-4/5
      md:w-11/12
      xl:my-10
      md:my-4
      md:mx-auto
      m-1
      bg-gray-50
      rounded
    "
  >
    <h1 class="font-semibold xl:text-xl text-center p-4">Requests History</h1>
    <Table :items="items" :getTheDataInParent="getData" :readOnly="true" />
  </div>
</template>

<script>
import Table from './Table';

export default {
  components: {
    Table,
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_request_history`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            'jwt': localStorage.getItem('jwt'),
          }),
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  data() {
    return {
      items: [],
    };
  },
};
</script>

<style></style>
